/* eslint-disable react/no-array-index-key */
/* eslint-disable function-paren-newline */
import React, { useState, useEffect, useRef } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import Input from '@deprecated-ui/common/Input';
import Dropdown from '@deprecated-ui/screener/Dropdown';
import Menu from '@deprecated-ui/screener/Menu';
import color from '@deprecated-ui/_style/color';
import PropTypes from 'prop-types';
import AutoSuggestion from 'features/screener/components/AutoSuggestion';
import screenerSlice, { screenerSelectors } from 'features/screener/slice';
import { useDispatch, useSelector } from 'react-redux';
import DATA_CY from 'constants/data-cy';
import { IRulesNewScreener } from 'features/screener/types';
import {
  ContainerBasicScreener,
  ContainerScreenerRules,
  IconRemove,
  SSelect,
} from './styled';

const operatorOptions = ['>', '<', '<=', '=', '>='];

const ScreenerRules = ({
  defaultValue,
  onChangeRules,
  onRunScreener,
}: {
  defaultValue: {
    item1?: number;
    item1name?: string;
    item2?: number;
    item2name?: string;
    multiplier?: any;
    operator?: string;
    type?: string;
  }[];
  onChangeRules: (rules: IRulesNewScreener[]) => void;
  onRunScreener: () => void;
}) => {
  const [modalFinancialIndex, setModalFinancialIndex] = useState<number>(0);
  const [modalFinancialType, setModalFinancialType] = useState<string>('');
  const [screenerRules, setScreenerRules] = useState<IRulesNewScreener[]>([
    {
      type: 'basic',
      item1: null,
      item1name: '',
      operator: '>',
      item2: null,
      multiplier: '',
    },
  ]);
  const delayTimer = useRef(undefined);

  const {
    screenerModal: { financialModal },
  } = useSelector(screenerSelectors);

  const {
    actions: { setIsModalFinancialMetricActive },
  } = screenerSlice;

  const dispatch = useDispatch();

  const showModalFinancial = (
    indexRules: number,
    type: string,
    fieldName: string,
  ) => {
    dispatch(setIsModalFinancialMetricActive(true));
    setModalFinancialIndex(indexRules);
    setModalFinancialType(`${type}.${fieldName}`);
  };

  const onModalClosed = (id: string, name: string, modalType: string) => {
    if (modalType === 'basic.only') {
      setScreenerRules((prevState) =>
        Object.assign([], prevState, {
          [modalFinancialIndex]: {
            ...prevState[modalFinancialIndex],
            item1: id,
            item1name: name,
          },
        }),
      );
    } else {
      const [type, align] = modalType.split('.');
      setScreenerRules((prevState) =>
        Object.assign([], prevState, {
          [modalFinancialIndex]: {
            ...prevState[modalFinancialIndex],
            [`${align}`]: id,
            [`${align}name`]: name,
          },
        }),
      );
    }
  };

  const onAutocompleteSelect = (
    id: number,
    name: string,
    idx: number,
    type: string,
    fieldName: string,
  ) => {
    if (type === 'basic') {
      setScreenerRules((prevState) =>
        Object.assign([], prevState, {
          [idx]: {
            ...prevState[idx],
            item1: id,
            item1name: name,
          },
        }),
      );
    } else {
      setScreenerRules((prevState) =>
        Object.assign([], prevState, {
          [idx]: {
            ...prevState[idx],
            [fieldName]: id,
            [`${fieldName}name`]: name,
          },
        }),
      );
    }
  };

  const onOperatorSelect = (value, idx) => {
    setScreenerRules((prevState) =>
      Object.assign([], prevState, {
        [idx]: {
          ...prevState[idx],
          operator: value,
        },
      }),
    );
  };

  const onInputRules = (input, idx, fieldName: string) => {
    const { value } = input.target;
    setScreenerRules((prevState) =>
      Object.assign([], prevState, {
        [idx]: {
          ...prevState[idx],
          [fieldName]: value,
        },
      }),
    );
  };

  const onChooseScreenerType = (item) => {
    const { key } = item;
    if (key === 'basic-ratio') {
      setScreenerRules((prevState) =>
        prevState.concat([
          {
            type: 'basic',
            item1: null,
            item1name: '',
            operator: '>',
            item2: null,
            multiplier: '',
          },
        ]),
      );
    } else {
      setScreenerRules((prevState) =>
        prevState.concat([
          {
            type: 'compare',
            item1: null,
            item1name: '',
            operator: '>',
            multiplier: '',
            item2: null,
            item2name: '',
          },
        ]),
      );
    }
  };

  const onRemoveRules = (idx) => {
    const result = [
      ...screenerRules.slice(0, idx),
      ...screenerRules.slice(idx + 1),
    ];
    setScreenerRules(result);
  };

  const AddRules = ({
    onMenuClick,
  }: {
    onMenuClick: (item: string) => void;
  }) => {
    const RulesContent = (
      <Menu
        // @ts-expect-error
        onClick={(item: string) => {
          onMenuClick(item);
        }}
      >
        <Menu.Item key="basic-ratio">
          <Flex align="center">
            <Iconmoon className="icon-compose_plus" />{' '}
            {/* @ts-expect-error */}
            <Text pl="8px">Basic Ratio</Text>
          </Flex>
        </Menu.Item>
        <Menu.Item key="ratio-vs-ratio">
          <Flex align="center">
            <Iconmoon className="icon-compose_plus" />{' '}
            {/* @ts-expect-error */}
            <Text ml="8px">Ratio Vs Ratio</Text>
          </Flex>
        </Menu.Item>
      </Menu>
    );

    return (
      // @ts-expect-error
      <Dropdown overlay={RulesContent} trigger="click">
        {/* @ts-expect-error */}
        <Button p="6px 8px">
          <Flex justify="space-between" align="center">
            <Iconmoon className="icon-compose_plus" />
            <Text padding="0 0 0 8px">Add a Rule</Text>
          </Flex>
        </Button>
      </Dropdown>
    );
  };

  useEffect(() => {
    const { id, name } = financialModal;
    if (id && name) {
      onModalClosed(id, name, modalFinancialType);
    }
  }, [financialModal]);

  useEffect(() => {
    clearTimeout(delayTimer.current);
    delayTimer.current = setTimeout(() => {
      onChangeRules(screenerRules);
    }, 100);
  }, [screenerRules]);

  useEffect(() => {
    setScreenerRules(defaultValue);
  }, [defaultValue]);

  return (
    <Flex direction="column" width="100%">
      {/* @ts-expect-error */}
      <Text color={color.dimgray} weight="700" as="h3" pb="10px" family="bold">
        Screening Rules
      </Text>
      <ContainerScreenerRules>
        {screenerRules.map(
          (
            { type, item1name, operator, item2, multiplier, item2name },
            rulesIndex,
          ) => {
            if (type === 'basic') {
              return (
                <ContainerBasicScreener key={`${type}-${rulesIndex}`}>
                  <AutoSuggestion
                    width="50%"
                    paddingX="0px"
                    paddingT="0px"
                    type="financial"
                    selectedValue={item1name}
                    placeholder="Please enter the ratio name"
                    onClickSuggestion={(id, name) => {
                      onAutocompleteSelect(
                        id,
                        name,
                        rulesIndex,
                        type,
                        undefined,
                      );
                    }}
                  />
                  <Button
                    width="10px"
                    height="32px"
                    // @ts-expect-error
                    p="4px 11px"
                    onClick={() => {
                      showModalFinancial(rulesIndex, 'basic', 'only');
                    }}
                  >
                    <Iconmoon size="14px" className="icon-toolbar_down" />
                  </Button>
                  <SSelect
                    onChange={(e) => {
                      onOperatorSelect(e.target.value, rulesIndex);
                    }}
                  >
                    {operatorOptions.map((operation, operatorIndex) => (
                      <option
                        key={`operator-${operatorIndex + 1}`}
                        value={operation}
                        selected={operation === operator}
                      >
                        {operation}
                      </option>
                    ))}
                  </SSelect>
                  <Input
                    key={`${type}-${rulesIndex}`}
                    value={item2}
                    onChange={(e) => {
                      onInputRules(e, rulesIndex, 'item2');
                    }}
                    name="value"
                    width="45%"
                  />
                  <IconRemove
                    onClick={() => onRemoveRules(rulesIndex)}
                    data-cy={DATA_CY.SCREENER.DELETE_RULES_BUTTON}
                  />
                </ContainerBasicScreener>
              );
            }
            return (
              <ContainerBasicScreener key={`${type}-${rulesIndex}`}>
                <AutoSuggestion
                  width="calc((90% - 165px)/ 2)"
                  paddingX="0px"
                  paddingT="0px"
                  type="financial"
                  selectedValue={item1name}
                  placeholder="Please enter the ratio name"
                  onClickSuggestion={(id, name) => {
                    onAutocompleteSelect(id, name, rulesIndex, type, 'item1');
                  }}
                />
                <Button
                  width="10px"
                  height="32px"
                  // @ts-expect-error
                  p="4px 11px"
                  onClick={() => {
                    showModalFinancial(rulesIndex, 'compare', 'item1');
                  }}
                >
                  <Iconmoon size="14px" className="icon-toolbar_down" />
                </Button>
                <SSelect
                  onChange={(e) => {
                    onOperatorSelect(e.target.value, rulesIndex);
                  }}
                >
                  {operatorOptions.map((operation, operatorIndex) => (
                    <option
                      key={`operator-${operatorIndex + 1}`}
                      value={operation}
                      selected={operation === operator}
                    >
                      {operation}
                    </option>
                  ))}
                </SSelect>
                <Input
                  key={`${type}-${rulesIndex}`}
                  value={multiplier}
                  onChange={(e) => {
                    onInputRules(e, rulesIndex, 'multiplier');
                  }}
                  name="value"
                  width="10%"
                  // @ts-expect-error
                  mr="10px"
                />
                {/* @ts-expect-error */}
                <Flex
                  as="span"
                  align="center"
                  justify="center"
                  mr="10px"
                  style={{ fontWeight: 'bold' }}
                >
                  x
                </Flex>
                <AutoSuggestion
                  width="calc((90% - 165px)/ 2)"
                  paddingX="0px"
                  paddingT="0px"
                  type="financial"
                  selectedValue={item2name}
                  placeholder="Please enter the ratio name"
                  onClickSuggestion={(id, name) => {
                    onAutocompleteSelect(id, name, rulesIndex, type, 'item2');
                  }}
                />
                <Button
                  width="10px"
                  height="32px"
                  // @ts-expect-error
                  p="4px 11px"
                  onClick={() => {
                    showModalFinancial(rulesIndex, 'compare', 'item2');
                  }}
                >
                  <Iconmoon size="14px" className="icon-toolbar_down" />
                </Button>
                <IconRemove onClick={() => onRemoveRules(rulesIndex)} />
              </ContainerBasicScreener>
            );
          },
        )}
      </ContainerScreenerRules>
      {/* @ts-expect-error */}
      <Flex pt="15px">
        <AddRules onMenuClick={onChooseScreenerType} />
        {/* @ts-expect-error */}
        <Button ml="15px" type="primary" onClick={onRunScreener}>
          Screen
        </Button>
      </Flex>
    </Flex>
  );
};

ScreenerRules.defaultProps = {
  defaultValue: [],
};

ScreenerRules.propTypes = {
  defaultValue: PropTypes.instanceOf(Array),
};

export default React.memo(ScreenerRules);
